(() => {
  'use strict';

  const dialog = document.querySelector('[data-cm-art-viewer]');
  if (!dialog || typeof dialog.showModal !== 'function' || dialog.dataset.initialized) return;
  const find = (name) => dialog.querySelector(`[data-cm-art-${name}]`);
  const image = find('image');
  const stage = find('stage');
  const title = find('title');
  const count = find('count');
  const help = find('help');
  const original = find('original');
  const zoom = find('zoom');
  const previous = find('previous');
  const next = find('next');
  const close = find('close');
  const loading = find('loading');
  const error = find('error');
  if ([image, stage, title, count, help, original, zoom, previous, next, close, loading, error].some((element) => !element)) return;
  dialog.dataset.initialized = 'true';

  let slides = [];
  let currentIndex = 0;
  let opener = null;
  let backdropPointer = false;
  const idleHelp = 'Use Previous and Next to explore. Press Escape to close.';

  function enhanceLinks() {
    document.querySelectorAll('.cm-aplus-story .cm-aplus-image-link, .cm-aplus-story .cm-aplus-image-caption a').forEach((link) => {
      link.setAttribute('aria-haspopup', 'dialog');
      link.setAttribute('aria-controls', dialog.id);
      const label = link.getAttribute('aria-label');
      if (label) link.setAttribute('aria-label', label.replace(' (opens in a new tab)', ''));
      const hiddenLabel = link.querySelector('.visually-hidden');
      if (hiddenLabel) hiddenLabel.textContent = hiddenLabel.textContent.replace(' (opens in a new tab)', '');
    });
  }
  enhanceLinks();
  document.addEventListener('shopify:section:load', enhanceLinks);

  function setZoom(enabled) {
    stage.classList.toggle('is-zoomed', enabled);
    zoom.setAttribute('aria-pressed', String(enabled));
    zoom.textContent = enabled ? 'Fit image' : 'Zoom in';
    help.textContent = enabled ? 'Scroll or swipe across the image to see the details. Choose Fit image to see it all.' : idleHelp;
    if (enabled) {
      const fittedWidth = Math.min(stage.clientWidth, stage.clientHeight * (image.naturalWidth / image.naturalHeight || 2.44), 1464);
      stage.style.setProperty('--cm-art-zoom-width', `${Math.max(image.naturalWidth || 1464, fittedWidth * 2)}px`);
      stage.focus({ preventScroll: true });
    }
    stage.scrollLeft = 0;
    stage.scrollTop = 0;
  }

  function showImage(index) {
    currentIndex = (index + slides.length) % slides.length;
    const slide = slides[currentIndex];
    setZoom(false);
    title.textContent = slide.title;
    count.textContent = `Image ${currentIndex + 1} of ${slides.length}`;
    image.alt = slide.alt;
    original.href = slide.href;
    stage.setAttribute('aria-busy', 'true');
    loading.hidden = false;
    error.hidden = true;
    zoom.disabled = true;
    previous.disabled = next.disabled = slides.length < 2;
    image.src = slide.href;
    if (image.complete && image.naturalWidth) finishLoading();
  }

  function finishLoading() {
    if (!image.complete || !image.naturalWidth) return;
    stage.removeAttribute('aria-busy');
    loading.hidden = true;
    error.hidden = true;
    zoom.disabled = false;
  }

  image.addEventListener('load', finishLoading);
  image.addEventListener('error', () => {
    if (!image.complete || image.naturalWidth) return;
    stage.removeAttribute('aria-busy');
    loading.hidden = true;
    error.hidden = false;
    zoom.disabled = true;
  });

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('.cm-aplus-story .cm-aplus-image-link, .cm-aplus-story .cm-aplus-image-caption a');
    if (!link || link.hasAttribute('download')) return;
    const story = link.closest('.cm-aplus-story');
    const panel = link.closest('.cm-aplus-panel');
    const imageLink = panel?.querySelector('.cm-aplus-image-link');
    if (!imageLink || link.href !== imageLink.href) return;
    // Leave the original link untouched if a different modal already owns focus.
    if (document.querySelector('dialog[open], cart-drawer.active, cart-notification.active')) return;
    slides = Array.from(story.querySelectorAll('.cm-aplus-panel')).flatMap((item) => {
      const anchor = item.querySelector('.cm-aplus-image-link');
      const photo = anchor?.querySelector('img');
      if (!anchor || !photo) return [];
      return [{
        href: anchor.href,
        title: item.querySelector('h3')?.textContent.trim() || 'A closer look at Coiny Minds',
        alt: photo.alt || 'Coiny Minds product image'
      }];
    });
    const hero = document.querySelector('.cm-v13-hero-banner[data-cm-art-hero-original]');
    let heroOriginal = '';
    try {
      const heroValue = hero?.getAttribute('data-cm-art-hero-original');
      if (heroValue) heroOriginal = new URL(heroValue, document.baseURI).href;
    } catch (_) { /* An invalid optional hero link does not interrupt the gallery. */ }
    if (heroOriginal && !slides.some((slide) => slide.href === heroOriginal)) {
      slides.unshift({
        href: heroOriginal,
        title: document.querySelector('#CoinyHeroTitle')?.textContent.trim() || 'Raising the next generation of financially intelligent humans.',
        alt: hero.querySelector('img')?.alt || 'Coiny Minds money bank and its printed gift box'
      });
    }
    const index = slides.findIndex((slide) => slide.href === link.href);
    if (index < 0) return;
    try {
      dialog.showModal();
    } catch (_) {
      return;
    }
    event.preventDefault();
    opener = link;
    document.documentElement.classList.add('cm-art-viewer-open');
    showImage(index);
    close.focus({ preventScroll: true });
  });

  previous.addEventListener('click', () => showImage(currentIndex - 1));
  next.addEventListener('click', () => showImage(currentIndex + 1));
  zoom.addEventListener('click', () => setZoom(zoom.getAttribute('aria-pressed') !== 'true'));
  close.addEventListener('click', () => dialog.close());

  dialog.addEventListener('keydown', (event) => {
    // Zoomed images retain native arrow-key scrolling in the focusable stage.
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || stage.classList.contains('is-zoomed')) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      showImage(currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });

  dialog.addEventListener('pointerdown', (event) => {
    backdropPointer = event.target === dialog || event.target === stage;
  });
  dialog.addEventListener('click', (event) => {
    if (backdropPointer && (event.target === dialog || event.target === stage) && !stage.classList.contains('is-zoomed')) dialog.close();
    backdropPointer = false;
  });
  function restorePage() {
    document.documentElement.classList.remove('cm-art-viewer-open');
    setZoom(false);
    if (opener?.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  }
  dialog.addEventListener('close', restorePage);
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.contains?.(dialog) && dialog.open) {
      dialog.close();
      restorePage();
    }
  });
})();
